import {useState, useEffect} from 'react';
import styles from './CourseOutline.module.css';
import Chevron from "../../generic/shapes/chevron/Chevron"
import type {RootState} from "../../../store/store";
import {useSelector} from 'react-redux';

function Lesson({item, activeId, onSelect}) {
    const isActive = activeId === item.id;

    return (
        <li>
            <button
                className={`${styles.subsection} ${isActive ? styles.active : ''}`}
                onClick={() => onSelect(item.id)}
            >
                {item.completed
                    ? <span className={styles.completedCheck}>✓</span>
                    : <span className={styles.subsectionDot}/>
                }
                {item.title}
            </button>
        </li>
    );
}

function Chapter({item, activeId, onSelect, defaultOpen}) {
    const hasActive = item.lessons.some((l) => l.id === activeId);
    const [open, setOpen] = useState(defaultOpen || hasActive);

    useEffect(() => {
        setOpen(hasActive);
    }, [hasActive]);

    return (
        <li className={styles.chapterItem}>
            <button
                className={`${styles.chapter} ${hasActive ? styles.chapterHasActive : ''}`}
                onClick={() => setOpen((v) => !v)}
            >
                <Chevron open={open}/>
                <span>{item.title}</span>
            </button>
            {open && (
                <ul className={styles.subsectionList}>
                    {item.lessons.map((lesson) => (
                        <Lesson
                            key={lesson.id}
                            item={lesson}
                            activeId={activeId}
                            onSelect={onSelect}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
}

export default function CourseOutline({courseOutline, activeId, percent, onSelect, isOpen, onClose}: {
    courseOutline: any[] | null,
    activeId: number | null,
    percent: number,
    onSelect: (id: number) => void,
    isOpen?: boolean,
    onClose?: () => void,
}) {
    const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

    if (!courseOutline)
        return null;

    return (
        <nav className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
            <button className={styles.drawerClose} onClick={onClose} aria-label="Close lessons">✕</button>
            {isLoggedIn &&
                <>
                    <div className={styles.progressBar}>
                        <div className={styles.progressFill} style={{width: `${percent}%`}}/>
                    </div>
                    <p className={styles.progressLabel}>{percent}% complete</p>
                </>
            }
            <ul className={styles.chapterList}>
                {courseOutline.map((chapter, index) => (
                    <Chapter
                        key={chapter.id}
                        item={chapter}
                        activeId={activeId}
                        onSelect={onSelect}
                        defaultOpen={index === 0 && !activeId}
                    />
                ))}
            </ul>
        </nav>
    );
}